import { AutocompleteInput } from "react-admin";

const CategorySelectForSO = (props) => {
  return (
    <AutocompleteInput
      {...props}
      openOnFocus
      filterToQuery={(searchText) => ({
        name: searchText || "",
      })}
    />
  );
};

export default CategorySelectForSO;
